/**
 * Topbar — wordmark, puzzle stamp, countdown, streak indicator.
 * Hydrates the static markup from index.html with live values.
 */

import { dayName } from '@/game/melbourne';
import { startCountdown } from '@/game/countdown';

export interface TopbarHandle {
  setStreak(streak: number): void;
  destroy(): void;
}

export function mountTopbar(opts: { puzzleId: string; date: string; streak: number }): TopbarHandle {
  const stamp = document.getElementById('puzzle-stamp');
  const countdown = document.getElementById('countdown');
  const streakEl = document.getElementById('streak-indicator');

  if (stamp) {
    stamp.textContent = `${opts.puzzleId} · ${dayName(opts.date)}`;
  }
  let stop: (() => void) | null = null;
  if (countdown) {
    stop = startCountdown(countdown);
  }
  setStreakText(streakEl, opts.streak);

  return {
    setStreak: (streak) => setStreakText(streakEl, streak),
    destroy: () => stop?.(),
  };
}

function setStreakText(el: HTMLElement | null, streak: number): void {
  if (!el) return;
  if (streak > 0) {
    el.textContent = `\u{1F525}${streak}`;
    el.setAttribute('aria-label', `Current streak ${streak}`);
  } else {
    el.textContent = '';
  }
}
